module.exports = __webpack_public_path__ + "static/media/placeholder14.7c1c3f3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/src/img/placeholder14.jpg
// module id = 636
// module chunks = 0